import { Header, Button, BreadCrumb } from "@funcional/react-ui";
import { Restricted } from "@funcional/react-auth-ui";
import { QueryRulesForm } from "../components/";
import { useHistory } from "react-router-dom";

export default function QueryFixedDiscountRules() {
  const history = useHistory();

  return (
    <>
      <Header
        title="Regras de Desconto Fixo"
        buttons={
          <Restricted to="create.fixedDiscountRule">
            <Button
              color="primary"
              onClick={() => history.push(`/refund/fixed-discount-rule/new`)}
            >
              Nova regra de desconto fixo
            </Button>
          </Restricted>
        }
      >
        <BreadCrumb
          marginBottom={0}
          items={[{ label: "Nova regra de desconto fixo" }]}
        />
      </Header>
      <QueryRulesForm />
    </>
  );
}
